// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import HomePage from "./HomePage";
// import TutorPage from "./TutorPage";
// import StudentPage from "./StudentPage";
// import AdministratorPage from "./AdministratorPage";
// const RouterMain = () => {
//   return (
//     <div>
//       {/* <ScrollToTop/> */}
//       <Routes>
//        <Route path="/" element={<HomePage />} />
//         <Route path="/tutor" element={<TutorPage/>} />
//         <Route path="/student" element={<StudentPage/>} />
//         <Route path="/administrator" element={<AdministratorPage/>} />
//       </Routes>
//     </div>
//   );
// };

// export default RouterMain;

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TutorPage from "./TutorPage";
import StudentPage from "./StudentPage";
import AdministratorPage from "./AdministratorPage";
import RootPage from "./RootPage";
import EbookView from "./EbookView";
import Login from "./Login";
import BookList from "./BookList";
const RouterMain = () => {
  return (
    <div>
      {/* <ScrollToTop/> */}
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/tutor" element={<TutorPage />} />
        <Route path="/student" element={<StudentPage />} />
        <Route path="/administrator" element={<AdministratorPage />} />
        <Route path="/ebook-view" element={<EbookView />} />
        <Route path="/books" element={<EbookView />} />
        <Route path="/booklist" element={<BookList />} />
      </Routes>
    </div>
  );
};

export default RouterMain;
